import { Icon, LightEntity, LogoTypes, SvgIconNames } from '@design';
import clsx from 'clsx';
import { useMemo } from 'react';

import sharedStyles from '../../AssetLogo.module.scss';
import styles from './LogoPlaceholder.module.scss';

const getLogo = ({
  entity,
  type,
  subClassIcon,
  iconName,
}: {
  entity: LightEntity;
  type?: string;
  subClassIcon?: SvgIconNames;
  iconName: SvgIconNames;
}) => {
  switch (true) {
    case type === LogoTypes.StockInitial:
      return (
        <i className={styles.logoPlaceholder} data-testid="logo">
          {entity.name_short[0]}
        </i>
      );
    case type === LogoTypes.EquitySector:
      return (
        <div className={styles.iconWrap}>
          <Icon size={22} iconName={iconName} />
        </div>
      );
    case type === LogoTypes.FinancialInstrument:
      return (
        <div className={styles.iconWrap}>
          <Icon size={22} iconName="BadgePercentage" />
        </div>
      );
    case type === LogoTypes.Crypto:
      return (
        <img
          className={styles.cryptoImage}
          src="/app/static/images/icons/generic-cryptocurrency.svg"
          alt="crypto-icon"
          data-testid="crypto-icon"
        />
      );
    case type === LogoTypes.FxCurrency:
    case type === LogoTypes.Default:
      return (
        <div className={styles.iconWrap}>
          <Icon size={22} iconName="Coin" />
        </div>
      );
    case !!subClassIcon:
      return (
        <div className={styles.iconWrap}>
          <Icon size={22} iconName={subClassIcon} />
        </div>
      );
    default:
      return (
        <div className={styles.iconWrap}>
          <Icon size={22} iconName={'ChartLine'} />
        </div>
      );
  }
};

interface LogoPlaceholderProps {
  entity: LightEntity;
  className?: string;
  size: number;
  type?: string;
  subClassIcon?: SvgIconNames;
  iconName: SvgIconNames;
}

export const LogoPlaceholder = ({
  entity,
  type,
  className,
  size,
  subClassIcon,
  iconName,
}: LogoPlaceholderProps) => {
  const logoMemo = useMemo(() => {
    return getLogo({ entity, type, subClassIcon, iconName });
  }, [entity, type, subClassIcon, iconName]);
  return (
    <div
      className={clsx(sharedStyles.logoWrapper, className)}
      style={{ width: size, height: size }}
      data-logo-placeholder
      data-testid="logo-placeholder"
    >
      {logoMemo}
    </div>
  );
};
